var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159",
    transform: "translate(-490.835 -661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9602",
    "data-name": "Group 9602",
    transform: "translate(-0.165 -101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5406",
    "data-name": "Rectangle 5406",
    width: 28,
    height: 10,
    transform: "translate(496 762)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5411",
    "data-name": "Rectangle 5411",
    width: 10,
    height: 5,
    transform: "translate(496 771)",
    fill: "#31e5e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9601",
    "data-name": "Group 9601",
    transform: "translate(-0.165 -99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5405",
    "data-name": "Rectangle 5405",
    width: 28,
    height: 10,
    transform: "translate(491 779)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5412",
    "data-name": "Rectangle 5412",
    width: 10,
    height: 5,
    transform: "translate(509 776)",
    fill: "#31e5e5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectArrowLeft);
export default __webpack_public_path__ + "static/media/ConnectArrowLeft.1fce386de3d50b1bd315a3b5ed72eb99.svg";
export { ForwardRef as ReactComponent };